import { getLoadedVariationsForPrefix } from './variationMatching'

export const PRINTED_PATTERN_PREFIXES = ['Aspen', 'Bamboo', 'Geo', 'Pinstripe', 'Blossom', 'Strand'] as const

export type PrintedPatternPrefix = typeof PRINTED_PATTERN_PREFIXES[number]

export const isPrintedPattern = (prefix: string | undefined | null): prefix is PrintedPatternPrefix => {
  return !!prefix && (PRINTED_PATTERN_PREFIXES as readonly string[]).includes(prefix)
}

/** Saved variations define availability; Studio Config applies visibility separately. */
export const getColorsForPattern = (
  prefix: string | undefined | null,
  colors: readonly { label: string }[],
): string[] | null => {
  if (!isPrintedPattern(prefix)) return null
  // Strip both whitespace and hyphens so "Pinstripe-Oxford" and
  // "PinstripeOxford" match each other.
  const normalize = (label: string) => label.replace(/[\s-]/g, '')
  const np = normalize(prefix)
  const labels = new Set(getLoadedVariationsForPrefix(prefix).map(variation => normalize(variation.label)))
  return colors.filter(color => {
    const label = normalize(color.label)
    return labels.has(`${np}${label}`) || labels.has(`${label}${np}`)
  }).map(color => color.label)
}
